export class ToolsClass {
  static each (obj, callback) {
    if (typeof obj !== 'object' || typeof callback !== 'function') {
      return
    }
    Object.keys(obj).forEach(key => {
      callback(obj[key], key, obj)
    })
  }

  static sanitizeString (value) {
    if (typeof value !== 'string') {
      return ''
    }
    return value.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
  }

  static generateUUID () {
    const s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }
}
